var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIquanhe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 1.33337C4.25331 1.33337 2.83331 2.75337 2.83331 4.50004C2.83331 6.21337 4.17331 7.60004 5.91998 7.66004C5.97331 7.65337 6.02665 7.65337 6.06665 7.66004C6.07998 7.66004 6.08665 7.66004 6.09998 7.66004C6.10665 7.66004 6.10665 7.66004 6.11331 7.66004C7.81998 7.60004 9.15998 6.21337 9.16665 4.50004C9.16665 2.75337 7.74665 1.33337 5.99998 1.33337Z",
    fill: "#9A9A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38664 9.4333C7.52664 8.1933 4.49331 8.1933 2.61997 9.4333C1.77331 9.99996 1.30664 10.7666 1.30664 11.5866C1.30664 12.4066 1.77331 13.1666 2.61331 13.7266C3.54664 14.3533 4.77331 14.6666 5.99997 14.6666C7.22664 14.6666 8.45331 14.3533 9.38664 13.7266C10.2266 13.16 10.6933 12.4 10.6933 11.5733C10.6866 10.7533 10.2266 9.9933 9.38664 9.4333Z",
    fill: "#9A9A9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3267 4.89332C13.4333 6.18665 12.5133 7.31999 11.24 7.47332C11.2333 7.47332 11.2333 7.47332 11.2267 7.47332H11.2067C11.1667 7.47332 11.1267 7.47332 11.0933 7.48665C10.4467 7.51998 9.85334 7.31332 9.40668 6.93332C10.0933 6.31998 10.4867 5.39999 10.4067 4.39999C10.36 3.85998 10.1733 3.36665 9.89334 2.94665C10.1467 2.81999 10.44 2.73999 10.74 2.71332C12.0467 2.59999 13.2133 3.57332 13.3267 4.89332Z",
    fill: "#9A9A9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.66 11.0599C14.6067 11.7066 14.1933 12.2666 13.5 12.6466C12.8333 13.0133 11.9933 13.1866 11.16 13.1666C11.64 12.7333 11.92 12.1933 11.9733 11.6199C12.04 10.7933 11.6467 9.99994 10.86 9.36661C10.4133 9.01327 9.89333 8.73327 9.32666 8.52661C10.8 8.09994 12.6533 8.38661 13.7933 9.30661C14.4067 9.79994 14.72 10.4199 14.66 11.0599Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIquanhe);
export default __webpack_public_path__ + "static/media/iquanhe.ff4dbcd2c1c931f1021b9ede71d43518.svg";
export { ForwardRef as ReactComponent };